import apiClient from '@/api/index'

export const newsModule = {
    namespaced: true,

    state:() => ({
        storyIndex: null,
        isStoriesActive: false,
        stories: []
    }),

    mutations: {
        showStory(state, boolean) {
            state.isStoriesActive = boolean;
        },

        setStories(state, data) {
            state.stories = data
        },

        setStoryIndex(state, data) {
            state.storyIndex = data
        }
    },

    actions: {
        async fetchNews() {
            return apiClient.get(`/projects/tcode/news`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                if(response.status == 200) {
                    return response.data.results
                } else {
                    alert('Ошибка получения новостей')
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async setReaction({}, data) {
            const payload = {
                [data.type]: data.id,
                reaction_type: data.reaction
            }

            return await apiClient.post(`/projects/tcode/reactions/`,
                payload,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async delReaction({}, id) {
            return apiClient
                .delete(`/projects/tcode/reactions/${id}`,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async fetchStories({ commit }) {
            return apiClient.get(`/projects/tcode/shops/tcode/stories/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setStories', response.data)
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }
}